export default __webpack_public_path__ + "static/media/audio_23_moto.153fa588.mp3";